export const convertNumber = (string) => {
  if (!string) return 0;
  if (typeof string === 'number') return string;
  return Number(string.replace(/,/g, ''));
};

export const calculatePaymentWithTermsSurcharge = (number) => {
  const price = +number;

  if (isNaN(price) || number <= 0) return 0;

  return price * 0.05;
};

export const calculateTotalPaymentWithTermsSurcharge = (number) => {
  const price = +number;

  if (isNaN(price) || number <= 0) return 0;

  return price + price * 0.05;
};

export const calculateCreditSurcharge = (number) => {
  const price = +number;

  if (isNaN(price) || number <= 0) return 0;

  return price * 0.03;
};

export const calculateTotalCreditSurcharge = (number) => {
  const price = +number;

  if (isNaN(price) || number <= 0) return 0;

  return price + price * 0.03;
};

export const calculateDiscountOnePercent = (number) => {
  const price = +number;

  if (isNaN(price) || number <= 0) return 0;

  return price * 0.01;
};

export const calculateTotalDiscountOnePercent = (number) => {
  const price = +number;

  if (isNaN(price) || number <= 0) return 0;

  return price - price * 0.01;
};

export const calculateDiscountPercent = (number, percentage, maximumValueOnDiscount = 0) => {
  const price = +number;

  if (isNaN(price) || number <= 0) return 0;

  const discount = price * (percentage / 100);
  return (maximumValueOnDiscount > 0 && discount > maximumValueOnDiscount) ? maximumValueOnDiscount : discount;
};

export const calculateTotalDiscountPercent = (number, percentage, maximumValueOnDiscount = 0) => {
  if (!percentage || percentage === 0) {
    return number;
  }

  const price = +number;

  if (isNaN(price) || number <= 0) return 0;

  const discount = price * (percentage / 100);
  return price - ((maximumValueOnDiscount > 0 && discount > maximumValueOnDiscount) ? maximumValueOnDiscount : discount);
};
